// extracted by mini-css-extract-plugin
export default {"productGallery":"RG-z","inQuickShop":"SG-z"};